import { TOfferCategory } from '../../../../types/offer';
import { getIsDailyRent } from './getIsDailyRent';

export function getPaymentPeriod(category: TOfferCategory | null): string {
  return getIsDailyRent(category) ? 'сутки' : 'мес.';
}
